// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var ExtErrors__OverlayBlocking$SmartcutsMacros = require("./ExtErrors__OverlayBlocking.bs.js");
var SelectorOverrideWithoutScope$SmartcutsMacros = require("./commands/shared/SelectorOverrideWithoutScope.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("./InterfaceBtwnContentScriptAndBg.bs.js");
var SelectionSemantics__InputCursorSemantics__Errors$SmartcutsMacros = require("./SelectionSemantics/SelectionSemantics__InputCursorSemantics__Errors.bs.js");
var SelectionSemantics__InputSelectionSemantics__Errors$SmartcutsMacros = require("./SelectionSemantics/SelectionSemantics__InputSelectionSemantics__Errors.bs.js");
var SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros = require("./SelectionSemantics/SelectionSemantics__NonInputSelectionSemantics__Errors.bs.js");
var SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros = require("./SelectionSemantics/SelectionSemantics__ContentEditableCursorSemantics__Types.bs.js");
var SelectionSemantics__ContentEditableSelectionSemantics__Errors$SmartcutsMacros = require("./SelectionSemantics/SelectionSemantics__ContentEditableSelectionSemantics__Errors.bs.js");

function searchElementTimedOut_encode(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "ms",
                Decco.floatToJson(v.ms)
              ]
            ]);
}

function searchElementTimedOut_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var ms = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ms"), null));
    if (ms.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                ms: ms._0
              }
            };
    }
    var e = ms._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".ms" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function querySelectorTimedOut_encode(v) {
  return Js_dict.fromArray([
              [
                "querySelector",
                Decco.stringToJson(v.querySelector)
              ],
              [
                "ms",
                Decco.floatToJson(v.ms)
              ]
            ]);
}

function querySelectorTimedOut_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var querySelector = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "querySelector"), null));
  if (querySelector.TAG === /* Ok */0) {
    var ms = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ms"), null));
    if (ms.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                querySelector: querySelector._0,
                ms: ms._0
              }
            };
    }
    var e = ms._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".ms" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = querySelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".querySelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode(v) {
  if (v) {
    return ["CouldNotCaptureScreenshot"];
  } else {
    return ["CouldNotGetBoxModel"];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CouldNotCaptureScreenshot" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CouldNotCaptureScreenshot */1
                  };
          }
      case "CouldNotGetBoxModel" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CouldNotGetBoxModel */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  if (v) {
    return "CouldNotCaptureScreenshot";
  } else {
    return "CouldNotGetBoxModel";
  }
}

var PlaybackCaptureScreenshotError = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(encoder_constrain, encoder_domElement, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* CdpUnableToGetContentQuads */0 :
          return ["CdpUnableToGetContentQuads"];
      case /* CdpUnableToGetDocument */1 :
          return ["CdpUnableToGetDocument"];
      case /* TabOrWindowNotVisible */2 :
          return ["TabOrWindowNotVisible"];
      case /* TabOrWindowVisibilityUnknownOrUnloaded */3 :
          return ["TabOrWindowVisibilityUnknownOrUnloaded"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* NonInputSelectionSemanticError */0 :
          return [
                  "NonInputSelectionSemanticError",
                  SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
      case /* InputSelectionSemanticError */1 :
          return [
                  "InputSelectionSemanticError",
                  SelectionSemantics__InputSelectionSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
      case /* InputCursorSemanticError */2 :
          return [
                  "InputCursorSemanticError",
                  SelectionSemantics__InputCursorSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
      case /* ContentEditableCursorSemanticError */3 :
          return [
                  "ContentEditableCursorSemanticError",
                  SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.semanticError_encode(v._0)
                ];
      case /* ContentEditableSelectionSemanticError */4 :
          return [
                  "ContentEditableSelectionSemanticError",
                  SelectionSemantics__ContentEditableSelectionSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
      case /* OverlayStillBlockingElementAfterMs */5 :
          return [
                  "OverlayStillBlockingElementAfterMs",
                  ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(encoder_domElement, v._0)
                ];
      case /* ErrorWhileWaitForPossibleOverlayToDisappear */6 :
          return [
                  "ErrorWhileWaitForPossibleOverlayToDisappear",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      case /* SearchElementTimedOut */7 :
          return [
                  "SearchElementTimedOut",
                  searchElementTimedOut_encode(v._0)
                ];
      case /* QuerySelectorOverridesTimedOut */8 :
          return [
                  "QuerySelectorOverridesTimedOut",
                  Decco.arrayToJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_encode, v._0)
                ];
      case /* ErrorWhileSearchForElement */9 :
          return [
                  "ErrorWhileSearchForElement",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      case /* CdpQuerySelectorTimedOut */10 :
          return [
                  "CdpQuerySelectorTimedOut",
                  querySelectorTimedOut_encode(v._0)
                ];
      case /* ErrorWhileCdpQuerySelector */11 :
          return [
                  "ErrorWhileCdpQuerySelector",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      case /* PlaybackCaptureScreenshotError */12 :
          return [
                  "PlaybackCaptureScreenshotError",
                  t_encode(v._0)
                ];
      case /* ContentScriptResponseError */13 :
          return [
                  "ContentScriptResponseError",
                  InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v._0)
                ];
      case /* UnhandledContentScriptPromiseError */14 :
          return [
                  "UnhandledContentScriptPromiseError",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      
    }
  }
}

function t_decode$1(decoder_constrain, decoder_domElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CdpQuerySelectorTimedOut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = querySelectorTimedOut_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CdpQuerySelectorTimedOut */10,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CdpUnableToGetContentQuads" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CdpUnableToGetContentQuads */0
                  };
          }
      case "CdpUnableToGetDocument" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CdpUnableToGetDocument */1
                  };
          }
      case "ContentEditableCursorSemanticError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContentEditableCursorSemanticError */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ContentEditableSelectionSemanticError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = SelectionSemantics__ContentEditableSelectionSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContentEditableSelectionSemanticError */4,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ContentScriptResponseError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContentScriptResponseError */13,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "ErrorWhileCdpQuerySelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ErrorWhileCdpQuerySelector */11,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "ErrorWhileSearchForElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ErrorWhileSearchForElement */9,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "ErrorWhileWaitForPossibleOverlayToDisappear" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */6,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "InputCursorSemanticError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = SelectionSemantics__InputCursorSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InputCursorSemanticError */2,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "InputSelectionSemanticError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = SelectionSemantics__InputSelectionSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InputSelectionSemanticError */1,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "NonInputSelectionSemanticError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NonInputSelectionSemanticError */0,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "OverlayStillBlockingElementAfterMs" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(decoder_domElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OverlayStillBlockingElementAfterMs */5,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "PlaybackCaptureScreenshotError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PlaybackCaptureScreenshotError */12,
                      _0: v0$11._0
                    }
                  };
          }
          var e$11 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "QuerySelectorOverridesTimedOut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = Decco.arrayFromJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* QuerySelectorOverridesTimedOut */8,
                      _0: v0$12._0
                    }
                  };
          }
          var e$12 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "SearchElementTimedOut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = searchElementTimedOut_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SearchElementTimedOut */7,
                      _0: v0$13._0
                    }
                  };
          }
          var e$13 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "TabOrWindowNotVisible" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TabOrWindowNotVisible */2
                  };
          }
      case "TabOrWindowVisibilityUnknownOrUnloaded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TabOrWindowVisibilityUnknownOrUnloaded */3
                  };
          }
      case "UnhandledContentScriptPromiseError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UnhandledContentScriptPromiseError */14,
                      _0: v0$14._0
                    }
                  };
          }
          var e$14 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

exports.searchElementTimedOut_encode = searchElementTimedOut_encode;
exports.searchElementTimedOut_decode = searchElementTimedOut_decode;
exports.querySelectorTimedOut_encode = querySelectorTimedOut_encode;
exports.querySelectorTimedOut_decode = querySelectorTimedOut_decode;
exports.PlaybackCaptureScreenshotError = PlaybackCaptureScreenshotError;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
/* Selector-SmartcutsMacros Not a pure module */
